module.exports = __webpack_public_path__ + "img/contact_qrcode.6148eeba.jpg";